import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import Parse, { attributesToProps, domToReact } from 'html-react-parser';

import PageSectionHeader from './SectionHeader';

const PageSectionHTML = ({ section }) => {
  const replace = (node) => {
    if (node.name === 'div' && node.attribs) {
      const properties = attributesToProps(node.attribs);
      if (properties.className) {
        properties.className = '';
      }
      return (
        <div {...properties}>
          {domToReact(node.children)}
        </div>
      );
    }
    return node;
  };

  return (
    <div className="custom-page-section landing-html">
      <Container>
        <PageSectionHeader section={section} />
        {Parse(section.content, {
          trim: true,
          replace,
        })}
      </Container>
    </div>
  );
};

PageSectionHTML.propTypes = {
  section: PropTypes.object.isRequired,
};

export default PageSectionHTML;
